import React from 'react';

const DataProviderIcon = ({
  style = {},
  fill = '#3a84a8',
  width = '100%',
  className = '',
  height = '100%',
  viewBox = '0 0 1024 1024',
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M921.65625,32 H95.34375 C42.686191406249996,32 0,79.27320019721985 0,137.5892791748047 v774.3213806152344 c0,58.316078977584844 42.686191406249996,105.58927917480469 95.34375,105.58927917480469 h826.3125 c52.657558593750004,0 95.34375,-47.27320019721984 95.34375,-105.58927917480469 V137.5892791748047 c0,-58.316078977584844 -42.686191406249996,-105.58927917480469 -95.34375,-105.58927917480469 zM444.9375,876.7142333984375 H127.125 v-211.17855834960938 h317.8125 v211.17855834960938 zm0,-351.9642639160156 H127.125 v-211.17855834960938 h317.8125 v211.17855834960938 zm444.9375,351.9642639160156 H572.0625 v-211.17855834960938 h317.8125 v211.17855834960938 zm0,-351.9642639160156 H572.0625 v-211.17855834960938 h317.8125 v211.17855834960938 z"
    />
  </svg>
);

export default DataProviderIcon;
